import { isArray } from 'util';
import { ValidationDetailSummary } from '../validation-detail-summary';

export class ValidationDetailSummaryBuilder {
  static fromJson(json) {
    return (json)
      ? new ValidationDetailSummary(
        json.hash,
        json.subactivityHash,
        json.subactivityName,
        json.programHash,
        json.programReference,
        json.printHash,
        json.printReference,
        json.manufacturingOrderHash,
        json.manufacturingOrderCode,
        json.materialHash,
        json.materialCode,
        json.materialFileName
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ValidationDetailSummaryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/validation-detail-summary.builder.ts